export default "__VITE_ASSET__BEzx2ypP__"